<div class="alert success-alert" @fadeAnimation>
    <span class="alert-icon"><img src="../../../../assets/confirmationIcon.png"></span>
    <span class="alert-message">
        <b>{{message1}}</b>
        <br>
        {{message2}}
    </span>
    <span class="close-btn" onclick="this.parentElement.style.display='none';" (click)="hideAlert()">&times;</span>
</div>